import React, { useEffect, useRef, useState } from "react";
import "./css/SigninEmailView.css";
import whiteArrow from "../../../assets/images/white-arrow.svg";
import { EMAIL_REGEX } from "utils/constants";
import { CircularProgress } from "@mui/material";

interface SigninEmailViewProps {
  isLoading: boolean;
  userEmail: string;
  setUserEmail: React.Dispatch<React.SetStateAction<string>>;
  onClickSendOTP: () => void;
}

const SigninEmailView: React.FC<SigninEmailViewProps> = ({
  isLoading,
  userEmail,
  setUserEmail,
  onClickSendOTP,
}) => {
  const [error, setError] = useState<string>("");
  const emailRef = useRef<HTMLInputElement>(null);

  const handleInputFocus = () => {
    emailRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (document.activeElement === emailRef.current) {
        setTimeout(() => {
          emailRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 150);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserEmail(event.target.value);
    if (error) {
      setError("");
    }
  };

  const validateEmail = (email: string): boolean => {
    return EMAIL_REGEX.test(email);
  };

  const handleSendOTP = () => {
    if (userEmail.trim() === "") {
      setError("Enter email address.");
      return;
    }
    if (!validateEmail(userEmail)) {
      setError("Invalid email address.");
      return;
    }
    setError("");
    onClickSendOTP();
  };

  return (
    <div className="signin-email-view-container">
      <p>Email</p>
      <input
        ref={emailRef}
        type="email"
        placeholder="hola@sabehub.com"
        value={userEmail}
        onChange={handleEmailChange}
        onFocus={handleInputFocus}
        autoComplete="email"
      />
      {error && <div className="error-message">{error}</div>}
      <div
        className="signin-email-view-button-container"
        style={{ marginTop: `${error ? "12px" : "34px"}` }}
        onClick={() => !isLoading && handleSendOTP()}
      >
        {isLoading ? (
          <CircularProgress size={30} color="inherit" />
        ) : (
          <>
            SEND ME OTP
            <img
              src={whiteArrow}
              className="signin-email-view-arrow-icon"
              alt="logo"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SigninEmailView;
